import React, { useState } from 'react';
import { X, Edit2, Trash2, Plus, Check, AlertCircle } from 'lucide-react';
import '../../../assests/css/admin/AdminAttributes/AdminAttributes.css';

const AdminAttributes = () => {
  const [attributes, setAttributes] = useState([
    {
      id: '#ATR2540',
      name: 'Color',
      type: 'Dropdown',
      values: 'Red, Blue, Green, Black, White',
      products: 145,
      status: 'Active',
      date: '07 Jan, 2021'
    },
    {
      id: '#ATR3924',
      name: 'Size',
      type: 'Radio Button',
      values: 'S, M, L, XL, XXL',
      products: 203,
      status: 'Active',
      date: '28 Sep, 2023'
    },
    {
      id: '#ATR1695',
      name: 'Material',
      type: 'Dropdown',
      values: 'Cotton, Polyester, Silk, Wool',
      products: 89,
      status: 'Active',
      date: '10 Aug, 2023'
    },
    {
      id: '#ATR8473',
      name: 'Brand',
      type: 'Dropdown',
      values: 'Nike, Adidas, Puma, Reebok',
      products: 167,
      status: 'Inactive',
      date: '22 May, 2023'
    },
    {
      id: '#ATR2150',
      name: 'Weight',
      type: 'Input Field',
      values: 'Numeric (kg)',
      products: 54,
      status: 'Active',
      date: '15 Mar, 2023'
    },
    {
      id: '#ATR5636',
      name: 'Pattern',
      type: 'Checkbox',
      values: 'Solid, Striped, Checked, Floral',
      products: 92,
      status: 'Active',
      date: '19 Dec, 2023'
    }
  ]);

  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertConfig, setAlertConfig] = useState({});
  const [editingAttribute, setEditingAttribute] = useState(null);
  const [selectedAttribute, setSelectedAttribute] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    type: 'Dropdown',
    values: '',
    status: 'Active'
  });

  const handleAddNew = () => {
    setEditingAttribute(null);
    setFormData({
      name: '',
      type: 'Dropdown',
      values: '',
      status: 'Active'
    });
    setShowModal(true);
  };

  const handleEdit = (attr, e) => {
    e.stopPropagation();
    setEditingAttribute(attr);
    setFormData({
      name: attr.name,
      type: attr.type,
      values: attr.values,
      status: attr.status
    });
    setShowModal(true);
  };

  const handleDelete = (attr, e) => {
    e.stopPropagation();
    setAlertConfig({
      type: 'danger',
      title: 'Delete Attribute?',
      message: `Are you sure you want to delete "${attr.name}"? This action cannot be undone.`,
      onConfirm: () => {
        setAttributes(attributes.filter(a => a.id !== attr.id));
        setShowAlert(false);
        showSuccessAlert('Deleted Successfully!', 'Attribute has been removed from the system.');
      }
    });
    setShowAlert(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editingAttribute) {
      setAttributes(attributes.map(attr =>
        attr.id === editingAttribute.id
          ? { ...attr, ...formData }
          : attr
      ));
      showSuccessAlert('Updated Successfully!', 'Attribute has been updated.');
    } else {
      const newAttr = {
        id: `#ATR${Math.floor(Math.random() * 9999)}`,
        ...formData,
        products: 0,
        date: new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
      };
      setAttributes([...attributes, newAttr]);
      showSuccessAlert('Created Successfully!', 'New attribute has been added.');
    }
    setShowModal(false);
  };

  const showSuccessAlert = (title, message) => {
    setAlertConfig({
      type: 'success',
      title,
      message,
      onConfirm: () => setShowAlert(false)
    });
    setShowAlert(true);
  };

  const handleRowClick = (attr) => {
    setSelectedAttribute(attr);
    setShowDetailModal(true);
  };

  return (
    <div className="AdminPanelAttributes">
      <div className="AdminPanelAttributes__container">
        <div className="AdminPanelAttributes__header">
          <h1 className="AdminPanelAttributes__title">All Attributes List</h1>
          <div className="AdminPanelAttributes__headerActions">
            <button
              className="AdminPanelAttributes__button AdminPanelAttributes__button--primary"
              onClick={handleAddNew}
            >
              <Plus size={20} />
              Add New Attribute
            </button>
            <div className="AdminPanelAttributes__dropdown">
              <button
                className="AdminPanelAttributes__dropdownButton"
                onClick={() => setShowDropdown(!showDropdown)}
              >
                This Month
              </button>
              {showDropdown && (
                <div className="AdminPanelAttributes__dropdownMenu">
                  <div className="AdminPanelAttributes__dropdownItem" onClick={() => setShowDropdown(false)}>
                    This Week
                  </div>
                  <div className="AdminPanelAttributes__dropdownItem" onClick={() => setShowDropdown(false)}>
                    This Month
                  </div>
                  <div className="AdminPanelAttributes__dropdownItem" onClick={() => setShowDropdown(false)}>
                    This Year
                  </div>
                  <div className="AdminPanelAttributes__dropdownItem" onClick={() => setShowDropdown(false)}>
                    All Time
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Table Wrapper Added */}
        <div className="AdminPanelAttributes__tableWrapper">
          <div className="AdminPanelAttributes__table">
            <div className="AdminPanelAttributes__tableHeader">
              <div></div>
              <div>ID</div>
              <div>Attribute Name</div>
              <div>Type</div>
              <div>Values</div>
              <div>Products</div>
              <div>Status</div>
              <div>Date</div>
              <div>Action</div>
            </div>
            {attributes.map((attr) => (
              <div
                key={attr.id}
                className="AdminPanelAttributes__tableRow"
                onClick={() => handleRowClick(attr)}
              >
                <input
                  type="checkbox"
                  className="AdminPanelAttributes__checkbox"
                  onClick={(e) => e.stopPropagation()}
                />
                <div className="AdminPanelAttributes__id">{attr.id}</div>
                <div>{attr.name}</div>
                <div>{attr.type}</div>
                <div>{attr.values}</div>
                <div>{attr.products}</div>
                <div>
                  <span className={`AdminPanelAttributes__status AdminPanelAttributes__status--${attr.status.toLowerCase()}`}>
                    {attr.status}
                  </span>
                </div>
                <div>{attr.date}</div>
                <div className="AdminPanelAttributes__actions">
                  <button
                    className="AdminPanelAttributes__iconButton AdminPanelAttributes__iconButton--edit"
                    onClick={(e) => handleEdit(attr, e)}
                  >
                    <Edit2 size={16} />
                  </button>
                  <button
                    className="AdminPanelAttributes__iconButton AdminPanelAttributes__iconButton--delete"
                    onClick={(e) => handleDelete(attr, e)}
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {showModal && (
        <div className="AdminPanelAttributes__modal" onClick={() => setShowModal(false)}>
          <div className="AdminPanelAttributes__modalContent" onClick={(e) => e.stopPropagation()}>
            <div className="AdminPanelAttributes__modalHeader">
              <h2 className="AdminPanelAttributes__modalTitle">
                {editingAttribute ? 'Edit Attribute' : 'Add New Attribute'}
              </h2>
              <button className="AdminPanelAttributes__closeButton" onClick={() => setShowModal(false)}>
                <X size={20} />
              </button>
            </div>
            <form className="AdminPanelAttributes__form" onSubmit={handleSubmit}>
              <div className="AdminPanelAttributes__formGroup">
                <label className="AdminPanelAttributes__label">Attribute Name</label>
                <input
                  type="text"
                  className="AdminPanelAttributes__input"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  required
                  placeholder="Enter attribute name"
                />
              </div>
              <div className="AdminPanelAttributes__formGroup">
                <label className="AdminPanelAttributes__label">Type</label>
                <select
                  className="AdminPanelAttributes__select"
                  value={formData.type}
                  onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                >
                  <option>Dropdown</option>
                  <option>Radio Button</option>
                  <option>Checkbox</option>
                  <option>Input Field</option>
                </select>
              </div>
              <div className="AdminPanelAttributes__formGroup">
                <label className="AdminPanelAttributes__label">Values (comma separated)</label>
                <textarea
                  className="AdminPanelAttributes__textarea"
                  value={formData.values}
                  onChange={(e) => setFormData({ ...formData, values: e.target.value })}
                  required
                  placeholder="e.g., Red, Blue, Green"
                />
              </div>
              <div className="AdminPanelAttributes__formGroup">
                <label className="AdminPanelAttributes__label">Status</label>
                <select
                  className="AdminPanelAttributes__select"
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                >
                  <option>Active</option>
                  <option>Inactive</option>
                </select>
              </div>
              <div className="AdminPanelAttributes__formActions">
                <button
                  type="button"
                  className="AdminPanelAttributes__button AdminPanelAttributes__button--secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="AdminPanelAttributes__button AdminPanelAttributes__button--submit"
                >
                  {editingAttribute ? 'Update' : 'Create'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {showDetailModal && selectedAttribute && (
        <div className="AdminPanelAttributes__modal" onClick={() => setShowDetailModal(false)}>
          <div className="AdminPanelAttributes__modalContent" onClick={(e) => e.stopPropagation()}>
            <div className="AdminPanelAttributes__modalHeader">
              <h2 className="AdminPanelAttributes__modalTitle">Attribute Details</h2>
              <button className="AdminPanelAttributes__closeButton" onClick={() => setShowDetailModal(false)}>
                <X size={20} />
              </button>
            </div>
            <div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">ID:</span>
                <span className="AdminPanelAttributes__detailValue">{selectedAttribute.id}</span>
              </div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">Name:</span>
                <span className="AdminPanelAttributes__detailValue">{selectedAttribute.name}</span>
              </div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">Type:</span>
                <span className="AdminPanelAttributes__detailValue">{selectedAttribute.type}</span>
              </div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">Values:</span>
                <span className="AdminPanelAttributes__detailValue">{selectedAttribute.values}</span>
              </div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">Products:</span>
                <span className="AdminPanelAttributes__detailValue">{selectedAttribute.products}</span>
              </div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">Status:</span>
                <span className="AdminPanelAttributes__detailValue">
                  <span className={`AdminPanelAttributes__status AdminPanelAttributes__status--${selectedAttribute.status.toLowerCase()}`}>
                    {selectedAttribute.status}
                  </span>
                </span>
              </div>
              <div className="AdminPanelAttributes__detailRow">
                <span className="AdminPanelAttributes__detailLabel">Date Created:</span>
                <span className="AdminPanelAttributes__detailValue">{selectedAttribute.date}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Alert Modal (SweetAlert Style) */}
      {showAlert && (
        <div className="AdminPanelAttributes__modal">
          <div className="AdminPanelAttributes__alert">
            <div className={`AdminPanelAttributes__alertIcon AdminPanelAttributes__alertIcon--${alertConfig.type}`}>
              {alertConfig.type === 'success' ? <Check size={40} /> : <AlertCircle size={40} />}
            </div>
            <h3 className="AdminPanelAttributes__alertTitle">{alertConfig.title}</h3>
            <p className="AdminPanelAttributes__alertMessage">{alertConfig.message}</p>
            <div className="AdminPanelAttributes__alertActions">
              {alertConfig.type === 'danger' && (
                <button
                  className="AdminPanelAttributes__button AdminPanelAttributes__button--secondary"
                  onClick={() => setShowAlert(false)}
                >
                  Cancel
                </button>
              )}
              <button
                className="AdminPanelAttributes__button AdminPanelAttributes__button--primary"
                onClick={alertConfig.onConfirm}
              >
                {alertConfig.type === 'danger' ? 'Yes, Delete' : 'OK'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminAttributes;